export const shipmentFormLastNameField = "shippingAddress.lastName";
export const shipmentFormFirstNameField = "shippingAddress.firstName";
export const shipmentFormPhoneNumberField = "shippingAddress.phoneNumber";
export const shipmentFormZipCodeField = "shippingAddress.postalCode";
export const shipmentFormPrefectureField = "shippingAddress.prefectureCode";
export const shipmentFormCityField = "shippingAddress.address1";
export const shipmentFormAddressField = "shippingAddress.address2";
export const shipmentFormBuildingNameAndRoomNumberField = "shippingAddress.buildingName";
export const shipmentFormMailField = "shippingAddress.mail";
export const shipmentFormDeliveryMethodField = "desiredDeliveryMethodTimeUuid";

export const shipmentFormTestId = "components/fragments/argyle/shipment-form/form";
export const shipmentFormTitleTestId = "components/fragments/argyle/shipment-form/title";
export const shipmentFormDescriptionTestId = "components/fragments/argyle/shipment-form/description";

export const shipmentFormSkeletonDeliveryMethodTimeTestId =
  "components/fragments/argyle/shipment-form/skeleton-DeliveryMethodTime";
